<template>
  <div class="text-center" style="margin-bottom:20px;">
    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto md-small-size-100 md-xsmall-size-100">
        <h2 class="title text-center" style="margin-top:10px; margin-bottom:10px;">{{buildingName}}</h2>
      </div>
      <div class="md-layout-item md-size-100" v-if="model.floors.length > 1">
        <div class="md-list no-margins no-paddings">
          <li class="md-list-item upper-list-item">
            <a
              class="md-list-item-router md-list-item-container md-button-clean dropdown"
              style="justify-content: center"
            >
              <div class="md-list-item-content">
                <drop-down direction="down" style="margin-top:2px">
                  <md-button
                    slot="title"
                    class="md-button md-button-link md-simple dropdown-toggle no-button-paddings"
                    data-toggle="dropdown"
                  >{{$t("Area")}}: {{floorName}}</md-button>
                  <ul class="dropdown-menu dropdown-with-icons">
                    <li :value="floor.id" v-for="floor in model.floors" :key="floor.id">
                      <a @click="selectFloor(floor)">{{floor.description[language.code].name}}</a>
                    </li>
                  </ul>
                </drop-down>
              </div>
            </a>
          </li>
        </div>
      </div>
      <div
        class="md-layout-item md-size-100 md-small-size-100 md-xsmall-size-100"
        v-if="rooms.length>1"
      >
        <div class="md-list no-margins no-paddings">
          <li class="md-list-item">
            <a
              class="md-list-item-router md-list-item-container md-button-clean dropdown"
              style="justify-content: center"
            >
              <div class="md-list-item-content">
                <drop-down direction="down" style="margin-top:2px">
                  <md-button
                    :disabled="rooms.length<2"
                    slot="title"
                    class="md-button md-button-link md-simple"
                    :class="{'dropdown-toggle' : rooms.length > 1}"
                    data-toggle="dropdown"
                  >
                    <span>{{$t("Room")}}: {{roomName}}</span>
                  </md-button>
                  <ul
                    class="dropdown-menu"
                    v-if="rooms.length>1"
                    style="max-height:400px; overflow-y:scroll;"
                  >
                    <li :value="room.id" v-for="room in rooms" :key="room.id">
                      <a @click="selectRoom(room)">{{room.description[language.code].name}}</a>
                    </li>
                  </ul>
                </drop-down>
              </div>
            </a>
          </li>
        </div>
      </div>

      <div class="md-layout-item md-size-100 mx-auto md-small-size-100 md-xsmall-size-100">
        <hr />
      </div>
      <div class="md-layout-item md-size-20 md-small-size-0"></div>
      <div class="md-layout-item md-size-60 md-small-size-100">
        <img
          v-if="roomImage"
          :src="fileUrl(roomImage)"
          :style="{ backgroundImage: 'url(' + fileUrl(currentImage) + ')',backgroundSize: '100% auto' }"
          width="100%"
        />
        <img v-else :src="fileUrl(currentImage)" width="100%" />
      </div>
      <div class="md-layout-item md-size-20 md-small-size-0"></div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";

export default {
  name: "BuildingDetail",
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  props: ["id", "floorId", "roomId", "readOnly"],
  data() {
    return {
      model: {
        description: {},
        floors: [],
        floorsSortedAlphabetically: false
      },
      rooms: [],
      currentImage: null,
      selectedFloor: null,
      selectedRoom: null,
      roomImage: null,
      floorName: "",
      roomName: "",
      buildingName: ""
    };
  },
  methods: {
    async loadData() {
      this.model = (
        await axios.get("public/conferences/conference/building", {
          params: {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code,
            id: this.id
          }
        })
      ).data;
      if (this.model.floorsSortedAlphabetically) {
        this.model.floors.sort(this.compareNames);
      } else {
        this.model.floors.sort((a, b) => (a.order > b.order ? 1 : -1));
      }
      this.model.floors.unshift({
        id: null,
        description: [
          {
            language: 0,
            name: ""
          },
          {
            language: 1,
            name: ""
          }
        ]
      });
      if (this.model.description[this.language.code].pictureFileId) {
        this.currentImage = this.model.description[
          this.language.code
        ].pictureFileId;
      } else {
        this.model.floors.splice(0, 1);
        if (this.model.floors[0]) {
          this.selectFloor(this.model.floors[0]);
        }
      }

      this.buildingName = this.model.description[this.language.code].name;

      if (this.floorId) {
        var matchingFloor = this.model.floors.filter(
          f => f.id == this.floorId
        )[0];
        this.selectFloor(matchingFloor);

        if (this.roomId) {
          var matchingRoom = this.rooms.filter(f => f.id == this.roomId)[0];
          this.selectRoom(matchingRoom);
        }
      }
    },
    fileUrl(id) {
      if (id) return axios.getFileUrl(id);
      else return "";
    },
    selectFloor(floor) {
      this.rooms = [];
      this.roomImage = null;
      this.roomName = "";

      if (floor.id) {
        this.currentImage = floor.description[this.language.code].pictureFileId;
        this.floorName = floor.description[this.language.code].name;
        let rooms = floor.rooms.map(a => ({ ...a }));

        if (floor.roomsSortedAlphabetically) {
          rooms.sort(this.compareNames);
        } else {
          rooms.sort((a, b) => (a.order > b.order ? 1 : -1));
        }
        rooms.unshift({
          id: null,
          description: [
            {
              language: 0,
              name: ""
            },
            {
              language: 1,
              name: ""
            }
          ]
        });
        this.rooms = rooms;
      } else {
        this.currentImage = this.model.description[
          this.language.code
        ].pictureFileId;
        this.floorName = "";
        this.roomImage = null;
      }
    },
    selectRoom(room) {
      if (room.id) {
        this.roomImage = room.description[this.language.code].pictureFileId;
        this.roomName = room.description[this.language.code].name;
      } else {
        this.roomImage = null;
        this.roomName = " ";
      }
    },
    compareNames(a, b) {
      const nameA = a.description[this.language.code].name.toUpperCase();
      const nameB = b.description[this.language.code].name.toUpperCase();

      let comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async id() {
      this.model = {};
      await this.loadData();
    },
    async language() {
      this.model = {};
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}
.no-items {
  color: #d6d6d6;
}

.page-header .container {
  max-width: 70% !important;
}
.upper-list-item {
  z-index: 3;
}
.no-margins {
  margin: 0px 0px 0px 0px;
}
.no-paddings {
  padding: 0px 0px 0px 0px;
}
.no-button-paddings * {
  padding: 0px 0px 0px 0px !important;
}
</style>
